import { tw } from "@careinfo/tailwind";
import { flexRender, Row, Table } from "@tanstack/react-table";

export default function TableBody({
  table,
  handleRowClick,
}: {
  table: Table<any>;
  handleRowClick: (row: Row<any>) => void;
}) {
  return (
    <tbody>
      <Rows table={table} handleRowClick={handleRowClick} />
    </tbody>
  );
}

function Rows({
  table,
  handleRowClick,
}: {
  table: Table<any>;
  handleRowClick: (row: Row<any>) => void;
}) {
  return (
    <>
      {table.getRowModel().rows.map((row) => {
        const isTotalRow = row.original?.isTotalRow;

        return (
          <tr
            key={row?.original?.id}
            data-id={row?.original?.id}
            onClick={() => handleRowClick(row)}
            className={tw`${
              isTotalRow
                ? "bg-gray-200 font-semibold text-primary "
                : "even:bg-gray-50 odd:bg-white hover:bg-gray-100 hover:transition-all cursor-pointer"
            }`}
          >
            {row.getVisibleCells().map((cell) => (
              <td
                key={row?.original?.id + cell.id}
                className={tw`py-2 text-left px-5`}
              >
                {flexRender(cell.column.columnDef.cell, cell.getContext())}
              </td>
            ))}
          </tr>
        );
      })}
    </>
  );
}
